module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "c-menu-restaurants u-fixed u-pos-tl u-zindex--4 u-fit",
    class: [_vm.menuIsOpen ? 'is-open' : 'is-closed']
  }, [_c('div', {
    staticClass: "c-menu-restaurants__overlay u-absolute u-pos-tl u-fit u-bg--black-near u-opacity--70 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }, [(!_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-menu-restaurants__overlay__close js-overlay-close u-absolute u-pos-tl u-inline-block"
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : (_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-menu-restaurants__overlay__close-mobile u-absolute u-pos-bl u-flex u-flex-ai--center u-flex-jc--center u-fit-w",
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-menu-restaurants__container u-relative u-zindex--2 u-flex u-flex-ai--start u-fit-w u-bg--white"
  }, [_c('div', {
    staticClass: "c-menu-restaurants__container__top-line u-absolute u-pos-tl u-fit-w u-bg--black-near u-opacity--5"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-menu-restaurants__container__wrapper js-menu-wrapper u-absolute u-pos-tl u-flex u-fit u-cursor-grab",
    style: ({
      'width': _vm.menuWrapperWidth + 'px'
    })
  }, _vm._l((_vm.restaurants), function(restaurant, index) {
    return _c('div', {
      staticClass: "c-menu-restaurants__container__wrapper__item u-absolute u-pos-bl u-flex u-flex-jc--end u-flex-fd--column u-overflow-h",
      class: ['c-menu-restaurants__container__wrapper__item--' + restaurant.menu_layout, 'c-menu-restaurants__container__wrapper__item--' + restaurant.menu_layout_text]
    }, [_c('div', {
      staticClass: "c-menu-restaurants__container__wrapper__item__link u-relative u-flex u-flex-fd--column u-flex-jc--end u-click-area-xxs t-link u-cursor-pointer",
      on: {
        "click": function($event) {
          _vm._onClickOnRestaurant(restaurant.slug)
        }
      }
    }, [_c('div', {
      staticClass: "c-menu-restaurants__container__wrapper__item__title u-flex u-flex-fd--column u-flex-jc--center"
    }, [(restaurant.shortname_splitted && restaurant.shortname_splitted.length >= 1 && restaurant.shortname_splitted[0]) ? _c('span', {
      staticClass: "u-block t-ffamily--domaine t-fweight--bold t-text--xxs u-uppercase",
      domProps: {
        "innerHTML": _vm._s(restaurant.shortname_splitted[0])
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "u-block t-ffamily--domaine t-fweight--light t-text--md-ls u-uppercase",
      class: [restaurant.shortname_splitted && restaurant.shortname_splitted[0] !== '' ? 'u-marg-t-xxs' : ''],
      domProps: {
        "innerHTML": _vm._s(restaurant.shortname_splitted && restaurant.shortname_splitted.length >= 2 && restaurant.shortname_splitted[1])
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-menu-restaurants__container__wrapper__item__image u-relative u-fit-w u-overflow-h"
    }, [_c('img', {
      staticClass: "c-menu-restaurants__container__wrapper__item__image__element u-absolute u-pos-center u-minw--100 u-minh--100",
      attrs: {
        "src": restaurant.home_main_image && restaurant.home_main_image.sizes && restaurant.home_main_image.sizes['300x300'],
        "alt": restaurant.title + ' - Four Seasons',
        "title": restaurant.title + ' - Four Seasons'
      }
    })])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "c-menu-restaurants__container__arrows u-marg-x-auto u-flex u-flex-jc--end u-w8of10 u-pad-y-sm"
  }, [_c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-ai--center"
  }, [_c('div', {
    staticClass: "c-menu-restaurants__container__arrows__arrow u-relative u-click-area-xxs",
    class: [_vm.scrollX > 50 ? 'is-visible' : 'is-hidden'],
    on: {
      "click": function($event) {
        _vm._onClickOnPrevious()
      }
    }
  }, [_c('img', {
    staticClass: "u-fit-w",
    attrs: {
      "src": "/static/medias/images/icons/four-seasons_icons_arrow-left--black.png",
      "alt": "Four Seasons - Previous",
      "title": "Four Seasons - Previous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-menu-restaurants__container__arrows__arrow u-relative u-marg-l-xs u-click-area-xxs",
    class: [_vm.scrollX < _vm.menuWrapperTranslateXMax - 50 ? 'is-visible' : 'is-hidden'],
    on: {
      "click": function($event) {
        _vm._onClickOnNext()
      }
    }
  }, [_c('img', {
    staticClass: "u-fit-w",
    attrs: {
      "src": "/static/medias/images/icons/four-seasons_icons_arrow-right--black.png",
      "alt": "Four Seasons - Next",
      "title": "Four Seasons - Next"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e45946"}!./src/scripts/components/app-menu-restaurants/template.html
// module id = 194
// module chunks = 0